// extracted by mini-css-extract-plugin
export default {"btnClose":"BackBtn_btnClose__FkhCY"};